<template>
  <router-view />
  <notifications
    group="custom-template"
    :duration="3000"
    :width="300"
    animation-name="v-fade-left"
    position="bottom right"
    class="my-notifications"
  >
    <template #body="props">
      <div class="custom-template">
        <div class="custom-template-icon">
          <img src="@/assets/notify/xiaoxi.png" alt="" style="" />
        </div>
        <div
          class="custom-template-content"
          style="max-width: 300px; overflow: hidden"
        >
          <div class="custom-template-title">
            {{ props.item.title }}
          </div>
          <div class="custom-template-text" v-html="props.item.text"></div>
        </div>
        <div class="custom-template-close" @click="props.close">
          <img src="@/assets/notify/delete.svg" alt="" style="" />
        </div>
      </div>
    </template>
  </notifications>
</template>

<script>
export default {
  name: "App",
  methods: {
    setContentStyle() {
      const rootHtml = document.documentElement || document.body;
      const windowScreen = document.documentElement;
      const windowScreenWidth = windowScreen.clientWidth;
      const windowScreenHeight = windowScreen.clientHeight;
      const screenRatio = 16 / 9;
      // this.$refs.systemFrame.style = `width:${windowScreenWidth}px;height:${windowScreenHeight}px;`
      // 1、先通过宽度，比高度：
      let contentWidth = windowScreenWidth;
      let contentHeight = windowScreenWidth / screenRatio;
      if (contentHeight <= windowScreenHeight) {
        // this.$refs.systemContent.style = `width:${contentWidth}px;height:${contentHeight}px`;
        const rem = contentWidth / 19.2;
        rootHtml.style.fontSize = `${rem}px`;
        return;
      }
      // 2、通过高度，计算宽度：
      contentHeight = windowScreenHeight;
      contentWidth = contentHeight * screenRatio;
      // this.$refs.systemContent.style = `width:${contentWidth}px;height:${contentHeight}px`;
      const rem = contentWidth / 19.2;
      rootHtml.style.fontSize = `${rem}px`;
    },
  },
  mounted() {
    this.setContentStyle();
    window.addEventListener("resize", this.setContentStyle);
  },
  unmounted() {
    window.removeEventListener("resize", this.setContentStyle);
  },
};
</script>

<style lang="scss">
body {
  /* 清除默认外边距 */
  margin: 0px;
  padding: 0px;
}
#app {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.el-table {
  --el-table-border-color: unset !important;
  --el-table-border: 0 !important;
  --el-table-header-bg-color: unset !important;
  background-color: transparent !important;
}
.el-table tr {
  background-color: unset !important;
}
:deep(.el-table tr th.el-table__cell) {
  border: 0;
  border-color: unset !important;
  // background-color: transparent !important;
}
:deep(.el-table .el-table__header tr:first-child) {
  // background-color: #001845 !important;
  border: 0;
  border-color: unset !important;
}
:deep(.el-table th.el-table__cell) {
  border: 0;
  border-color: unset !important;
}
/*去除底边框*/
:deep(.el-table .el-table__body tr td.el-table__cell) {
  border: 0;
  border-color: unset !important;
  // background-color: transparent !important;
}

/*
  EXAMPLES
*/
.my-notifications {
  margin-bottom: 10px;
  margin-right: 10px;
}
.custom-template {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 13px;
  margin: 5px;
  border-radius: 4px;
  padding: 0 10px;
  margin-bottom: 0;
  align-items: center;
  justify-content: center;
  &,
  & > div {
    box-sizing: border-box;
  }
  background-color: #3052ac;
  border: 2px solid #3052ac;
  opacity: 0.8;
  .custom-template-content {
    padding: 10px;
    flex: 1;
    .custom-template-title {
      letter-spacing: 1px;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #f0f2f5;
    }
    .custom-template-text {
      font-size: 12px;
      color: #f0f2f5;
    }
  }
  .custom-template-close {
    width: 20px;
    padding: 0 2px;
    &:hover {
      cursor: pointer;
    }
  }
}
.block {
  display: flex;
}
.v-fade-left-enter-active,
.v-fade-left-leave-active,
.v-fade-left-move {
  transition: all 0.5s;
}
.v-fade-left-enter,
.v-fade-left-leave-to {
  opacity: 0;
  transform: translateX(500px) scale(0.2);
}
.el-dialog.preWarningModal {
  position: fixed;
  background-color: transparent;
  // background-image: url(@/assets/preWarning/弹窗背景.png);
  background-image: url(@/assets/preWarning/预警面板.gif);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 5vh !important;
  top: 5vh;
  bottom: 5vh;
  right: 5vw;
  left: 5vw;
  padding: 45px !important;

  // height: 75% !important;
  // margin-top: 10vh !important;
  display: flex;
  border-radius: 4px;
  // background-color: #0s12f7a;
  .el-dialog__header {
    width: 0;
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
}
.el-pagination.custom-pagination-class.is-background .btn-next:disabled,
.el-pagination.custom-pagination-class.is-background .btn-prev:disabled {
  color: #fff !important;
  background-color: transparent !important;
}
.el-pagination.custom-pagination-class.is-background .btn-next,
.el-pagination.custom-pagination-class.is-background .btn-prev,
.el-pagination.custom-pagination-class.is-background .el-pager li {
  background-color: transparent;
}
.el-dialog.linkPanelModal {
  position: fixed;
  background-color: transparent;
  // background-image: url(@/assets/preWarning/弹窗背景.png);
  background-image: url(@/assets/dashboard/link-modal/modal_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 5vh !important;
  top: 5vh;
  bottom: 5vh;
  right: 5vw;
  left: 5vw;
  padding: 45px !important;

  // height: 75% !important;
  // margin-top: 10vh !important;
  display: flex;
  border-radius: 4px;
  // background-color: #0s12f7a;
  .el-dialog__header {
    width: 0;
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
}
.el-dialog.preWarningContentModal {
  position: fixed;
  background-color: transparent;
  background-image: url(@/assets/preWarning/弹窗背景.png);
  // background-image: url(@/assets/preWarning/预警面板.gif) ;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 5vh !important;
  top: 5vh;
  bottom: 5vh;
  right: 5vw;
  left: 5vw;
  padding: 45px !important;

  // height: 75% !important;
  // margin-top: 10vh !important;
  display: flex;
  border-radius: 4px;
  // background-color: #0s12f7a;
  .el-dialog__header {
    width: 0;
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
}
.el-dialog.linkPanelModal {
  position: fixed;
  background-color: transparent;
  .el-dialog__header {
    width: 0;
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }
}
</style>
